import { createContext } from "react";

const hrCostsContext = createContext();

export default hrCostsContext;